"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiBarcode = void 0;
const JsBarcode = require("jsbarcode");
const react_1 = require("react");
const React = require("react");
const logger_1 = require("shared/logger");
require("./barcode.less");
const log = new logger_1.Logger("barcode");
class UiBarcode extends react_1.Component {
    shouldComponentUpdate(nextProps) {
        return Object.keys(this.props).some((k) => this.props[k] !== nextProps[k]);
    }
    componentDidMount() {
        this.update();
    }
    componentDidUpdate() {
        this.update();
    }
    update() {
        const renderElement = this.refs.renderElement;
        try {
            JsBarcode(renderElement, this.props.value, Object.assign(Object.assign({}, this.props), { format: this.props.format || CONFIG.barcodeFormat }));
        }
        catch (e) {
            // prevent stop the parent process
            log.error(e);
        }
    }
    render() {
        const { renderer = "svg" } = this.props;
        if (renderer === "canvas") {
            return React.createElement("canvas", { ref: "renderElement" });
        }
        else {
            return React.createElement("svg", { ref: "renderElement" });
        }
    }
}
exports.UiBarcode = UiBarcode;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/barcode/barcode.tsx
// module id = 2812
// module chunks = 0 1